import { BreadCrumb } from 'primereact/breadcrumb'
import 'primeicons/primeicons.css'

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { InputText } from 'primereact/inputtext';
import { useState } from 'react';

function Files() {
  const items = [{ label: 'Files', path: '/files' }, { label: 'Submissions', path: '/submissions' }]
  const home = { icon: 'pi pi-home', url: '/' }

  const data = [
    { fileName: 'Provider File 1', version: '1', mostRecentSubmission: 'yes', dateUploaded: '10/03/2024 3:12:41 PM', uploadedBy: 'Test User', hasErrors: 'No', status: 'View' },
    { fileName: 'Provider File 2', version: '1', mostRecentSubmission: 'yes', dateUploaded: '10/03/2024 3:12:41 PM', uploadedBy: 'Sample User', hasErrors: 'Yes', status: 'View' },
    { fileName: 'Provider File 3', version: '1', mostRecentSubmission: 'yes', dateUploaded: '10/03/2024 3:12:41 PM', uploadedBy: 'Test User', hasErrors: 'No', status: 'View' },
  ];

  const [filteredData, setFilteredData] = useState(data);


  const handleSearch = (e:any) => {
    const value = e.target.value.toLowerCase();
    const filtered = data.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(value)
      )
    );
    setFilteredData(filtered);
  }

  return (
    <>
        <BreadCrumb model={items} home={home} />
        <p>Files</p>
        {/* <MegaMenu model={navigationItems} breakpoint='960px' /> */}
      <div className="card">
        <div style={{ marginBottom: '20px', marginLeft: '20px' }}>
          <InputText
            type="text"
            placeholder="Search..."
            onChange={(e) => { handleSearch(e) }}
          />
        </div>
        <div>
          <DataTable value={filteredData}>
            <Column field="fileName" header="File Name" />
            <Column field="version" header="Version" />
            <Column field="mostRecentSubmission" header="Most Recent Submission" />
            <Column field="dateUploaded" header="Date Uploaded" />
            <Column field="uploadedBy" header="Uploaded By" />
            <Column field="hasErrors" header="Has Errors" />
            <Column field="status" header="Status" />
          </DataTable>
        </div>
      </div>
    </>
  )
}

export default Files